<template>
    <div class="bg-black/30 w-full h-full flex justify-center items-center">
        <div class="bg-base-100 rounded shadow-lg p-4">
            <div class="title text-2xl">
                Redigere bilag
                <span class="text-primary ml-2">2025-123</span>
            </div>
            <div class="mt-6">
                <div class="flex gap-2 mb-2">
                    <i class="i-ph-files text-primary text-xl mb-1"/>
                    <div class="">Vedlegg</div>
                </div>
                <div>
                    <div class="flex flex-col ml-4">
                        <div v-for="i in 3" :key="i" class="flex gap-2 items-center w-fit">
                            <span class=""><i class="i-ph-file-pdf"/>Dokument {{ i }}</span>
                            <span class="i-ph-eye text-primary"/>
                        </div>
                        <button class="btn btn-sm btn-outline btn-primary flex items-center w-fit text-primary">
                            Last opp
                            <i class="i-ph-upload text-primary text-xl inline-block -mb-1"/>
                        </button>
                    </div>
                </div>
            </div>
            <div class="mt-10">
                <div class="flex gap-2 mb-2">
                    <i class="i-ph-hard-drives text-primary text-xl mb-1"/>
                    Transaksjon
                </div>
                <div class="grid ml-4" :style="gridTemplateCols">
                    <div
                        v-for="field in primaryFields"
                        :key="field.key"
                        class="text-left whitespace-nowrap truncate"
                        :title="field.label"
                        :style="field.style || {}"
                    >
                        {{ field.label }}
                    </div>
                    <div/>
                    <create-transaction-line
                        v-for="(line, index) in transactionEntryLines"
                        :key="line.entryUuid"
                        ref="entries"
                        :line="line"
                        :index="index"
                    />
                </div>
            </div>
            <div class="mt-10">
                <div class="flex gap-2 mb-2">
                    <i class="i-ph-invoice text-primary text-xl mb-1"/>
                    Faktura
                </div>
                <div class="flex ml-4">
                    <div class="w-24">Fakturanr</div>
                    <div class="w-24">Forfallsdato</div>
                    <div class="w-72">KID</div>
                    <div class="w-72">Bankkontonummer</div>
                </div>
                <div class="flex ml-4">
                    <input class="input border border-base-200 outline-none input-sm rounded-none w-24">
                    <input class="input border border-base-200 outline-none input-sm rounded-none w-24">
                    <input class="input border border-base-200 outline-none input-sm rounded-none w-72">
                    <input class="input border border-base-200 outline-none input-sm rounded-none w-72">
                </div>
            </div>
            <div class="mt-10">
                <div class="flex gap-2 mb-2">
                    <i class="i-ph-currency-dollar-simple text-primary text-xl mb-1"/>
                    Betaling
                </div>
                <div class="ml-4 border p-1 flex gap-3 items-center">
                    <i class="i-ph-hourglass inline-block text-primary -mb-0.5"/>
                    Betaling til godkjenning
                    -
                    <div class="text-primary">1920 - Driftskonto</div>
                    -
                    <div class="text-error">{{ formatCurrency(9876) }}</div>
                    <div class="grow" />
                    <div class="text-error flex items-center"><i class="i-ph-warning inline-block text-lg mr-1"/> Beløp er endret</div>
                    <i class="i-ph-pencil"/>
                    <i class="i-ph-prohibit text-error"/>
                </div>
            </div>
            <div class="flex justify-end mt-6 gap-2">
                <button class="btn btn-outline">Avbryt</button>
                <button class="btn btn-primary">Lagre</button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

import CreateTransactionLine from '@/transaction/create-transaction/CreateTransactionLine.vue'
import {useTransactionCreator} from '@/transaction/create-transaction/TransactionCreator.service'
import {computed} from 'vue'
import useDynamicTransactionFields, {TransactionInputField} from '@/transaction/create-transaction/transaction-fields.controller'
import {formatCurrency} from '@/services/formatter.service'

const {primaryFields} = useDynamicTransactionFields()

const {transactionEntryLines} = useTransactionCreator()
const gridTemplateCols = computed(() => {
    return 'grid-template-columns: ' + primaryFields.value.map((field: TransactionInputField) => {
        const min = field.style?.minWidth || 'auto'
        const max = field.style?.maxWidth || 'auto'
        return field.style?.width || `minmax(${min}, ${max})`
    }).join(' ') + ' auto'
})

</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";

input {
    @apply focus:outline-none;
}
</style>